import {useEffect, useState} from 'react'
import {getLocalstorage} from './utils'
import {useUserInfoContext} from '@/store/userInfo'
import item from "@/components/Descriptions/Item";

// 获取本地存储的用户信息
export const getUserInfo = () => {
    return getLocalstorage('userinfo')
}
// 获取有权限的品牌
export const usePpOptions = () => {
    const [options, setOptions] = useState([])
    const [allOptions, setAllOptions] = useState([
        {label: "东成", value: "东成"},
        {label: "DCA", value: "DCA"},
        {label: "DCK", value: "DCK"},
    ])
    const {baseInfo} = useUserInfoContext()
    useEffect(() => {
        if (baseInfo.qx && baseInfo.qx.ppqx) {
            const ppqx = JSON.parse(baseInfo.qx.ppqx)
            const options1 = []
            for (const ppqxItem of allOptions) {
                for (const ppqxItemElement of ppqx) {
                    if([1,2].includes(ppqxItemElement.qxz) && ppqxItemElement.pp === ppqxItem.value) {
                        options1.push({
                            label: ppqxItemElement.pp,
                            value: ppqxItemElement.pp,
                            item: ppqxItemElement
                        })
                    }
                }
            }
            setOptions(options1)
            // setOptions(ppqx.filter(p => [1, 2].includes(p.qxz)).map(p => ({
            //     label: p.pp,
            //     value: p.pp,
            //     item: p
            // })))
        }
    }, [baseInfo])
    return [options, allOptions]
}

// 获取有权限的品牌
export const useSdgjPpOptions = () => {
    const [options, setOptions] = useState([])
    const [allOptions, setAllOptions] = useState([
        {label: "东成", value: "东成"},
    ])
    const {baseInfo} = useUserInfoContext()
    useEffect(() => {
        if (baseInfo.qx && baseInfo.qx.ppqx) {
            const ppqx = JSON.parse(baseInfo.qx.ppqx)
            setOptions(ppqx.filter(p => p.pp==='东成').map(p => ({
                label: p.pp,
                value: p.pp,
                item: p
            })))
        }
    }, [baseInfo])
    return [options, allOptions]
}

// 生成行号
export const getHhMax = (data, filed, step = 10) => {
    const rows = data.filter(item => item.isdel === 'N');
    if (rows.length === 0) {
        return step;
    }
    rows.sort((a, b) => {
        return Number(b[filed]) - Number(a[filed])
    })
    return Number(rows[0][filed]) + step
}

export const getPxxhMax = (data, step = 1) => {
    const rows = data.filter(item => item.isdel === 'N');
    if (rows.length === 0) {
        return step;
    }
    rows.sort((a, b) => {
        return b.pxh - a.pxh
    })
    return rows[0].pxh + step
}

export const sortFn = (filed) => {
    return (a, b) => {
        const an = Number(a[filed])
        const bn = Number(b[filed])
        if (an > bn) {
            return 1
        }
        if (an < bn) {
            return -1
        }
        return 0
    }
}

